export default __webpack_public_path__ + "static/media/createCourseWhite.a0615b03.svg";